import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { OperatorMarker } from "./operator-marker";
import { useSocketOperators } from "@/api/operators";
import { useShortcutsStore } from "@/screens/dashboard/shortcuts.store";

export const AllOperatorsLocations = ({ zoomLevel }: { zoomLevel: number }) => {
  const { showOperators } = useShortcutsStore();
  const { operators } = useSocketOperators({
    limit: 100,
    status: "ON_DUTY,OFF_DUTY",
  });

  if (!showOperators || !operators || operators.length === 0) return null;

  return (
    <>
      {operators
        .filter((operator) => operator.lastLocation)
        .map((operator) => (
          <AdvancedMarker
            key={operator.id}
            position={{
              lat: operator.lastLocation.lat,
              lng: operator.lastLocation.lng,
            }}
          >
            <OperatorMarker operator={operator} zoomLevel={zoomLevel} />
          </AdvancedMarker>
        ))}
    </>
  );
};
